import axios from 'axios';
import mainApi from './mainApi';
import { getEnvVariables } from '../helpers/getEnvVariables';

const { QUOTER_URL, QUOTER_API_KEY } = getEnvVariables();

/**
 * Login del agente que llega embebido (iframe) con su identidad por params.
 * axios "pelado" (no quoterApiInstance): aún no hay token y no debe correr el interceptor de refresh.
 * El backend exige strings y no acepta apQuoteId vacío, por eso sólo se envía si existe.
 */
export const agentAuthenticatedLogin = async ({ userId, agentId, agentNumber, lang, apQuoteId }) => {
  const { data } = await axios.post(
    `${QUOTER_URL}/authentication/mvc/login/agents/authenticated`,
    {
      userId: String(userId),
      agentId: String(agentId),
      agentNumber: String(agentNumber ?? ''),
      lang,
      ...(apQuoteId && { apQuoteId: String(apQuoteId) }),
    },
    { headers: { 'x-api-key': QUOTER_API_KEY } }
  );

  const { token, refreshToken } = data?.data ?? {};
  if (!token) throw new Error('Agent login response without token');
  return { token, refreshToken };
};

export const loginRequest = async (username, password) => {

  try {
    const response = await mainApi.post(`/authenticate`, { username, password });
    return response.data;
  } catch (error) {
    throw error;
  }
};